export enum Period {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly'
}
export const defaultPeriod = Period.Daily;
export const periodQueryParamName  = 'period';
